import React from 'react';
import ContentPage from 'src/components/ContentPage/ContentPage';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NoAccess: React.FC = () => {
  const { t: tCommon } = useTranslation();

  return (
    <ContentPage title={tCommon('noAccess')}>
      <p>{tCommon('noAccessExplanation')}</p>
      <Link to="/">
        <u>{tCommon('goToMainPage')}</u>
      </Link>
    </ContentPage>
  );
};

export default NoAccess;
